import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyboard, midi, keys, piano"><path fillRule="evenodd" clipRule="evenodd" d="M3.75 3C3.33579 3 3 3.33579 3 3.75V21.25C3 21.6642 3.33579 22 3.75 22H20.25C20.6642 22 21 21.6642 21 21.25V3.75C21 3.33579 20.6642 3 20.25 3H3.75ZM6.5 4.5H4.5V20.5H8V13.5H7.25C6.83579 13.5 6.5 13.1642 6.5 12.75V4.5ZM9.5 20.5H14.5V13.5H13.75C13.3358 13.5 13 13.1642 13 12.75V4.5H11V12.75C11 13.1642 10.6642 13.5 10.25 13.5H9.5V20.5ZM17.5 4.5V12.75C17.5 13.1642 17.1642 13.5 16.75 13.5H16V20.5H19.5V4.5H17.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconKeyboard;
